import { getRestaurantCall, RestaurantData, updateRestaurantCall } from 'api/app/restaurant';
import { RestaurantActionTypes } from 'types/app/restaurant';
import { AppActionTypes } from 'types/app/app';
import { AppDispatch } from 'redux/store';

const restaurantActions = {
  getRestaurant(populateFields: string | null = null) {
    return async (dispatch: AppDispatch) => {
      try {
        const response = await getRestaurantCall(populateFields);
        dispatch({
          type: RestaurantActionTypes.Loaded,
          payload: response,
        });
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  updateRestaurant(data: RestaurantData) {
    return async (dispatch: AppDispatch) => {
      dispatch({ type: AppActionTypes.DisableSubmit });

      try {
        await updateRestaurantCall(data);
        dispatch({
          type: RestaurantActionTypes.Loaded,
          payload: {
            info: data.info,
            address: {
              ...data.address,
              formatted_address: data.address?.description || '',
            },
            social_media: data.social_media,
          },
        });
      } catch (error) {
        throw error;
      } finally {
        dispatch({ type: AppActionTypes.EnableSubmit });
      }
    };
  },
};

export default restaurantActions;
